/**
 * The mark's own spectrum
 * -------------------------------------------------------------
 * These are the gradient stops inside the WonderWorks W, read straight off
 * public/favicon.svg — the same ramp that runs blue through magenta to orange
 * across the letterform.
 *
 * Kept as `r, g, b` triples rather than hex because everything that uses them
 * needs an alpha as well: `rgba(var(--tile-glow), 0.18)`. A hex string cannot
 * be given one without being taken apart again in CSS.
 */
export const BRAND_SPECTRUM: string[] = [
  '63, 151, 183',
  '40, 111, 159',
  '27, 85, 144',
  '25, 71, 137',
  '53, 63, 130',
  '93, 57, 122',
  '128, 47, 111',
  '147, 37, 105',
  '166, 36, 103',
  '197, 57, 108',
  '237, 89, 110',
  '240, 104, 100',
  '242, 119, 82',
  '243, 133, 58',
  '244, 148, 44',
  '247, 158, 45',
  '248, 168, 45',
  '249, 179, 46',
]

/**
 * One colour per item, spread evenly across the whole ramp.
 *
 * Deliberately not random. A random colour is a different colour on every
 * reload, which reads as a rendering fault rather than a decision, and two
 * neighbours can land on near-identical blues. Sampling by position gives each
 * tile its own hue, keeps them in the mark's own order, and puts the same
 * colour in the same place every time the page opens.
 */
export function spectrumColor(index: number, total: number): string {
  if (total <= 1) return BRAND_SPECTRUM[0]
  const step = (BRAND_SPECTRUM.length - 1) / (total - 1)
  return BRAND_SPECTRUM[Math.round(index * step)]
}
